import {EnvironmentService} from '../../wa-services/environment-service';
import {WaHelperService} from '../../wa-services/wa-helper-service';


export class NewsItem {

  public title: string;
  public summary: string;
  public body: string;
  public author: string;
  public photo: string;
  public date: Date;
  public formattedDate: string;
  public video: string;


  constructor(rawNewsItem: any, protected env: EnvironmentService, protected helper: WaHelperService) {
    this.title = rawNewsItem.title;
    this.summary = this.preprocessHTMLField(rawNewsItem.summary);
    this.body = this.preprocessHTMLField(rawNewsItem.body);
    this.author = rawNewsItem.author;
    this.photo = rawNewsItem.photo ? rawNewsItem.photo.src : null;

    // @WORKAROUND @TODO: Subsitute because Drupal doesnt send the date in the
    // correct format: https://stackoverflow.com/questions/13363673/javascript-date-is-invalid-on-ios
    this.date = new Date(rawNewsItem.date.replace(' ', 'T'));
    this.formattedDate = this.helper.formatDate(this.date);
    // @FIXME @TODO Only 'embed' URLs are valid, check here? check in drupal?
    this.video = rawNewsItem.video ? rawNewsItem.video.replace('watch?v=', 'embed/') : null;
  }

  // @FIXME @TODO: Try to convert relative URL to absolute.
  protected preprocessHTMLField(value: string) {
    // @TODO @FIXME Imrpove performance
    return value
      .replace(new RegExp('(src=\\"\/\/)', 'gm'), (str: string, p1: string) => this.regExpReplacerHelperForRelativeURL(str, 'src'))
      .replace(new RegExp('(href=\\"\/\/)', 'gm'), (str: string, p1: string) => this.regExpReplacerHelperForRelativeURL(str, 'href'))
      .replace(new RegExp('(src=\\"\/)', 'gm'), (str: string) => this.regExpReplaceHelperForProtocolRelative(str, 'src'))
      .replace(new RegExp('(href=\\"\/)', 'gm'), (str: string) => this.regExpReplaceHelperForProtocolRelative(str, 'href'))
  }


  protected regExpReplaceHelperForProtocolRelative(str: string, attr: string) {
    return `${attr}="${this.env.getWAServerURL()}/`
  }

  protected regExpReplacerHelperForRelativeURL(str: string, attr: string) {
    return `${attr}="https://`;
  }
}